import React, { useState, useRef } from 'react';
import './ImageHero.scss';
import CTAButton from '../UI/CTA/CTAButton/CTAButton';
import Modal from 'react-modal';
import PlayButton from '../UI/CTA/PlayButton/PlayButton';
import { videoDataLayer } from '../../util/videoDataLayer';
const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

/**
 * Renders the image hero
 * @param {string} title
 * @param {string} description
 * @param {string} ctaText
 * @param {string} ctaLink
 * @param {boolean} showCta
 * @param {object} image
 * @param {boolean} showVideoCta
 * @param {object} videoCta
 * @param {string} backgroundColor
 * @param {string} textColor
 * @param {boolean} isHubspot
 * @returns {JSX.Element}
 * @constructor
 */
const ImageHero = ({
  title,
  description,
  ctaText,
  ctaLink,
  showCta,
  image,
  showVideoCta,
  videoCta,
  backgroundColor = 'gray',
  textColor = 'black',
  isHubspot = false,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const modal = useRef();
  let content;

  /**
   * Controls the toggling of a video modal.
   */
  const toggleModal = () => {
    setModalOpen(!modalOpen);
    modalOpen ? enableBodyScroll(modal) : disableBodyScroll(modal);
  };

  const afterModalOpen = () => disableBodyScroll(modal);
  const afterModalClose = () => enableBodyScroll(modal);

  const modalStyles = {
    content: {
      zIndex: 2,
    },
  };

  const contentRefCallback = (node) => {
    const { dataLayer } = window;
    if (modalOpen) {
      if (node) {
        content = node;
        const video = content.querySelector('video');

        if (video) {
          videoDataLayer(video, dataLayer);
        }
      }
    }
  };

  return (
    <div className={`c-image-hero background-color-${backgroundColor}`}>
      <div className="c-image-hero__inner">
        <div className="c-image-hero__text">
          <div className={`c-image-hero__title h4-right-grotesk color-${textColor}`}>
            <h4>{title}</h4>
          </div>
          {isHubspot && description && (
            <div
              className={`c-image-hero__description body-1 color-${textColor}`}
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
          )}
          {!isHubspot && description && (
            <div className={`c-image-hero__description body-1 color-${textColor}`}>
              <p>{description}</p>
            </div>
          )}
          {showCta && (
            <div className="c-image-hero__cta">
              <CTAButton
                type={'secondary'}
                link={ctaLink}
                text={ctaText}
                target={'_self'}
                additionalClasses={`cta color-${textColor}`}
              />
            </div>
          )}
          {showVideoCta && (
            <PlayButton
              text={videoCta.label}
              textClasses={`color-${textColor}`}
              onClick={toggleModal}
            />
          )}
        </div>
        <div className="c-image-hero__image-container">
          <img src={image.url} alt={image.alt} />
        </div>
      </div>
      {videoCta && (
        <Modal
          ref={modal}
          isOpen={modalOpen}
          onAfterOpen={afterModalOpen}
          onRequestClose={afterModalClose}
          className="c-image-hero__modal"
          styles={modalStyles}
          overlayClassName={'c-image-hero__modal-overlay'}
          contentRef={contentRefCallback}
        >
          <div className="c-image-hero__modal-overlay" onClick={toggleModal}></div>
          <div className="c-image-hero__modal-inner">
            <video
              id="modal-video"
              className="c-image-hero__modal-video"
              src={videoCta.link}
              autoPlay={true}
              muted={false}
              controls={true}
            >
              <source src={videoCta.link} />
            </video>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ImageHero;
